'use client';

import { SelectGoods } from './SelectGoods';
import type { CurationFormGoodsItem } from './type';

export interface SelectGoodsSelectionStepProps {
  className?: string;
  defaultCheckedProducts: CurationFormGoodsItem[];
  onSubmit: () => void;
}

/**
 * 큐레이션 상품 선택 2단계 UI.
 * NOTE: 전용 상품 검색/선택 화면이 준비되면 동일 Props를 유지한 채 이 컴포넌트 내부만 교체하면 됩니다.
 */
export function SelectGoodsSelectionStep(props: SelectGoodsSelectionStepProps) {
  return <SelectGoods {...props} />;
}
